export default __webpack_public_path__ + "static/media/azure.0145340f.svg";